import React, {useState, useEffect, useContext} from 'react';
import { TableContainer, Table, TableHead, TableRow, TableCell, TableBody,Paper } from '@material-ui/core/';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import MoreIcon from '@material-ui/icons/More';
import { sendGetRequest, sendPostRequest, sendDeleteRequest, sendPutRequest } from 'utils/api';
import { Link } from "react-router-dom";
import { UserContext } from "../contexts";


import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import Button from '@material-ui/core/Button';

const useStyles = makeStyles((theme) => ({

    tableRow: {
		height: '3em',
		backgroundColor: '#ececec',
		'&:nth-of-type(odd)': {
			backgroundColor: theme.palette.common.white,
		},
        cursor:'pointer'
	},

    tableRowHeader: {
		height: '3em',
		backgroundColor: '#3f51b5',
       
	},
    tableCellHeader:{
        color:'white',
       
    },
    tableCellIcon:{
        color:'#3f51b5'
    }
    

}));

  function createData(docNo, assignee, date, action) {
    return { docNo, assignee, date, action };
  }
  
  /*const rows = [
    createData('FAMAS-BGT-0001', 'Juan Dela Cruz', '10/20/2021','Open'),
    createData('FAMAS-BGT-0002', 'Juan Dela Cruz', '10/20/2021','Open'),
    createData('FAMAS-BGT-0003', 'Juan Dela Cruz', '10/20/2021','Open'),
    createData('FAMAS-BGT-0004', 'Juan Dela Cruz', '10/20/2021','Open'),
    createData('FAMAS-BGT-0005', 'Juan Dela Cruz', '10/20/2021','Open'),
  ];*/
   
  export default function ForApproval() {
    const userContext = useContext(UserContext);
  
    const classes = useStyles();
    const [forApproval, setForApproval] = useState([]);
    const [forReceiving, setForReceiving] = useState([]);
    const [forMmd, setForMmd] = useState([]);
    const [forProcessing, setForProcessing] = useState([]);
    
    const [approval, setApproval] = React.useState('');

    const handleChange = (event) => {
      setApproval(event.target.value);
    };
  

    const checkItems = async () =>{
      if(approval === '') return;

      //const res = await sendGetRequest(`/notification/details`);

      const res = await sendGetRequest(`/notification/subdetails/${approval}`);
      console.log("ERROR", res);

      if (res.error) {  
        alert(res.error.response.data.message);
				return;
			}
			
      setForApproval(res.data);
      //const resForProcessing = await sendGetRequest(``)

    }

    useEffect(() => {
      console.log("USER CONTEXT", userContext.userInfo.role);

      // if(userContext.userInfo.role === 'Admin'){
      //   setApproval("For MMD Approval");
      // }
        

      if(userContext.userInfo.role === 'Tl'){
        setApproval("For TL Approval");  
      }
        

      if(userContext.userInfo.role === 'User'){
        setApproval("For Receiving");
      }
        
      return () => {
      
      }
    }, [userContext.userInfo.role]);

    useEffect(()=>{

      checkItems();

    }, [approval])

    return (
      <div>
     
      <FormControl className={classes.formControl} fullWidth  variant="outlined">
          <InputLabel id="famasStatus">FAMAS Status</InputLabel>
          <Select
            labelId="famasStatus"
            id="famasStatus"
            
            label="FAMAS Status"
          
            value={approval}
            onChange={(e)=>{handleChange(e)}}
          >
            <MenuItem value="">
              <em>None</em>
            </MenuItem>
            <MenuItem value='For Receiving'>For Receiving</MenuItem>
            <MenuItem value='For My Approval'>For My Approval</MenuItem>
            <MenuItem value='For Approval'>For Approval</MenuItem>
            <MenuItem value='For TL Approval'>For TL Approval</MenuItem>
            
            {/* <MenuItem value='For MMD Processing'>For MMD Processing</MenuItem> */}
          </Select>
      </FormControl>
     


      <Typography component="h5" variant="h6" color="primary" gutterBottom style={{padding:"10px"}}>
        
      </Typography>
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }} size="small" aria-label="a dense table">
          <TableHead>
            <TableRow className={classes.tableRowHeader}>
              <TableCell className={classes.tableCellHeader}>Business Unit</TableCell>
              <TableCell className={classes.tableCellHeader}>DOC Number</TableCell>
              <TableCell className={classes.tableCellHeader}>Assignee</TableCell>
              <TableCell className={classes.tableCellHeader}>Date</TableCell>
              <TableCell className={classes.tableCellHeader}>View</TableCell>
              
            </TableRow>
          </TableHead>
          <TableBody>
            {forApproval.map((row) => (
              <TableRow
                key={row.name}
                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                className={classes.tableRow}
              >
                <TableCell>{row.businessUnit}</TableCell>
                <TableCell>{row.docNo}</TableCell>
                <TableCell>{row.assignee}</TableCell>
                <TableCell>{row.docDate}</TableCell>
                <TableCell className={classes.tableCellIcon}>
                  <Link color="inherit" to={`/famas/${row.idMaster}`} >
                     <MoreIcon/>
									</Link>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      
    
    </div>  
    );
  }
